import request from '@/util/request';
import qs from 'qs';

export const getTaskprojectList = (params, options) =>
  request.get('/api/inspectTaskProject/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectTaskProject/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectTaskProject/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/inspectTaskProject/submit', params, options);

export const update = (params, options) =>
  request.post('/api/inspectTaskProject/submit', params, options);
